export default "__VITE_ASSET__HcAc0KZX__"